<script setup>
import { Head, useForm, Link } from '@inertiajs/vue3';
import Toast from 'primevue/toast';
import { useToast } from 'primevue/usetoast';

const toast = useToast();
const props = defineProps({email: String, token: String});

const form = useForm({
    'email': props.email,
    'password': null,
    'password_confirmation': null,
    'token': props.token
});

function submit() {
    form.post('/wachtwoordaanpassen', {
        onSuccess: () => {
            toast.add({ severity: 'success', summary: 'Wachtwoord aangepast!', detail: 'Je kunt nu inloggen met je nieuwe wachtwoord.', life: 5000 })
            form.reset('password', 'password_confirmation');
            //
        },
        onError: () => {
            form.reset('password', 'password_confirmation');
        },
        preserveScroll: true
    })
}
</script>

<template>
    <Toast />
    <Head title="Wachtwoord aanpassen | Mijnautosnelweg" />
    <div class="flex min-h-full flex-1">
        <div class="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24 lg:w-[50%]">
            <div class="mx-auto w-full max-w-sm lg:w-96">
                <div>
                    <Link href="/">
                        <img class="" src="/public/img/logo_full.svg"/>
                    </Link>
                    <h2 class="mt-8 text-2xl font-bold leading-9 tracking-tight text-gray-900">Wachtwoord aanpassen
                    </h2>
                </div>

                <div class="mt-10">
                    <div>
                        <form @submit.prevent="submit" class="space-y-6">
                            <div>
                                <label for="email"
                                    class="block text-sm font-medium leading-6 text-gray-900">E-mailadres</label>
                                <div class="mt-2">
                                    <input id="email" name="email" v-model="form.email" type="email" autocomplete="email" required="" readonly
                                        class="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-brightorange sm:text-sm sm:leading-6" />
                                    <div v-if="form.errors.email" class="mt-2 text-red-500">{{ form.errors.email }}</div>
                                </div>
                            </div>

                            <div>
                                <label for="password"
                                    class="block text-sm font-medium leading-6 text-gray-900">Wachtwoord</label>
                                <div class="mt-2">
                                    <input id="password" name="password" v-model="form.password" type="password" autocomplete="password" required=""
                                        class="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-brightorange sm:text-sm sm:leading-6" />
                                    <div v-if="form.errors.password" class="mt-2 text-red-500">{{ form.errors.password }}</div>
                                </div>
                            </div>

                            <div>
                                <label for="password_confirmation"
                                    class="block text-sm font-medium leading-6 text-gray-900">Wachtwoord herhaling</label>
                                <div class="mt-2">
                                    <input id="password_confirmation" name="password_confirmation" v-model="form.password_confirmation" type="password" autocomplete="password" required=""
                                        class="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-brightorange sm:text-sm sm:leading-6" />
                                    <div v-if="form.errors.password_confirmation" class="mt-2 text-red-500">{{ form.errors.password_confirmation }}</div>
                                </div>
                            </div>

                            <div class="flex items-center justify-between">
                                <div class="text-sm leading-6">
                                    <Link href="/login" class="font-semibold text-royalblue-500 hover:text-royalblue-500/80">Naar inloggen</Link>
                                </div>
                            </div>

                            <div>
                                <button type="submit"
                                    class="flex w-full justify-center rounded-md bg-brightorange hover:bg-brightorange/80 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-brightorange focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brightorange">Wachtwoord aanpassen</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="relative hidden w-0 flex-1 lg:block">
            <img class="absolute left-0 right-0 top-0 bottom-0 h-full w-full object-cover"
                src="https://images.unsplash.com/photo-1496917756835-20cb06e75b4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1908&q=80"
                alt="" />
        </div>
    </div>
</template>